import React from 'react';
import '../styles/index.css'; // CSS für diese Seite (falls benötigt)
import wav from '../assets/swap.wav'; // Passe den Pfad zu deiner Datei an

function InvitationPage() {
    const soundEffect = new Audio();
    soundEffect.autoplay = true;

    const action = () => {
        if (!document.querySelector('.envelope').classList.contains('open')) {
            soundEffect.src = wav;
            soundEffect.play();
            document.querySelector('.envelope').addEventListener('click', function () {
                this.classList.remove('new');
                this.classList.add('open');
            });
            document.querySelector('.envelope').addEventListener('touchstart', function () {
                this.classList.remove('new');
                this.classList.add('open');
            });
        }
    };

    return (
        <div className="envelope new">
            <div className="front">
                <div className="mail">
                    <p>Einladung</p>
                    <button onClick={action}>Double click me</button>
                </div>
            </div>
            <div className="back">
                <div className="letter">
                    <p>Hi,</p>
                    <p>
                        hiermit lade ich Dich herzlich zu meinem 20. Geburtstag ein. Ich feiere ihn am 04.02.2023 ab 18.00 im Röllbacher Weg 9 in Röllbach. 🥳
                        Du kannst natürlich auch gerne deinen Freund/deine Freundin mitbringen.
                        Wir feiern eine Party mit dem Motto: Neon-lights.🎈 <br />
                        (Am besten kommt ihr in hellen Farben gekleidet)<br />
                        Sag mir bitte Bescheid, ob du kommen kannst.
                        Außer guter Laune ist nichts mitzubringen!!!<br />
                    </p>
                    <p>Ich würde mich freuen, wenn ihr kommt. 🥳</p>
                    <div className="box"></div>
                </div>
                <div className="flip left-flip"></div>
                <div className="flip right-flip"></div>
                <div className="flip bottom-flip"></div>
                <div className="flip top-flip"></div>
            </div>
        </div>
    );
}

export default InvitationPage;
